// extracted by mini-css-extract-plugin
export default {"form":"style_form__sBRiu","header":"style_header__moDVe","input":"style_input__OpIY4"};